// Shared API config
export const API_ENDPOINT = import.meta.env.VITE_BACKEND_URL;
export const API_AUTH_ENDPOINT = `${API_ENDPOINT}/auth`;
